import React from 'react';
import { Card } from 'react-bootstrap';
import('./About.css')

const About = () => {
    return (
        <div>
            <h3 className='service-title'>About Us
            </h3>


            <p>Dental Care is a fully dynamic, well structured and beautiful WordPress theme for Health and Medical websites. It is a highly suitable theme for doctors, dentists, hospitals, health clinics, surgeons, gynecologist and other type of health and medical related organizations.

                This theme has special features to manage appointment forms, services, doctors ,department, timetables, pricing tables, contact forms, newsletter and testimonials.

                Theme is fully supported with Visual Composer plugin to build easy and quick pages with dragging and dropping elements also prepared custom visual composer element for dynamic display of services, departments, doctors, blogs, testimonial and appointment form with different options.</p>
            <br />
            <br />
            <br />
            <br />
            <br />



        </div>

    );
};

export default About;